import(/* webpackMode: "eager" */ "/app/apps/web/src/app/[locale]/hautwissen/[slug]/page-content.tsx")